import React from 'react'
import { useQuery } from "@apollo/client";
import { PLAYLIST_GROUPS_QUERY } from "./Query/playlistGroupsQuery";
import { connect } from "react-redux";
import Loader from "../Loader/Loader";
import { Black, Shadow, WerfenColorMid } from "../../Constants/ColorChart";
import PlaylistsViewWrapper from "../PlaylistsView/PlaylistsViewWrapper";
import { Col, Container, Row } from "react-bootstrap";
import styled from "styled-components";

const WrapperDiv = styled.div`
    position: relative;
    color: ${ Black };
    text-align: center;
    margin-left: 15px;
    margin-right: auto;
    margin-top: 20px;
    padding-bottom: 2%;
    .flickity-prev-next-button.next {
        position: absolute;
        top: -25px;
    }
    
    .flickity-prev-next-button.previous {
        position: absolute;
        top: -25px;
        left: unset;
        right: 60px;
    }
`;

const PlaylistsViewTitle = styled.h1`
    font-weight: normal;
    font-size: 30px;
    text-align: left;
    margin-bottom: 1%;
    margin-right: 25%;
`;

const PlaylistGroups = ( props ) => {
    const { BUfilterArray, DfilterArray } = props;
    const { loading, error, data } = useQuery( PLAYLIST_GROUPS_QUERY,
        {
            variables: {
                "departments": DfilterArray,
                "business_units": BUfilterArray
            },
            fetchPolicy: "no-cache",
            notifyOnNetworkStatusChange: true,
            partialRefetch: true,
            returnPartialData: true
        } );

    if ( loading ) return (
        <Loader message="Loading Playlist Group" primaryColor={ WerfenColorMid }
                secondaryColor={ Shadow } fontColor={ WerfenColorMid }
                extraStyle={ "width: 200px; min-height: 368px; padding-top: 140px" }/>
    )

    if ( error ) {
        return <p key={ "error" }>Error: { JSON.stringify( error ) } </p>
    }

    if ( !data || !data.playlistGroupList || !data.playlistGroupList.length ) {
        return null
    }

    const { playlistGroupList } = data || [];

    return (
        <Container className="PlaylistGroup" style={ { zIndex: 0 } }>
            <Row>
                <Col xs={ 12 }>
                    { playlistGroupList.map( ( playlistGroup, index ) => {
                        if ( !playlistGroup.playlists.length ) {
                            return null
                        }

                        return (
                            <WrapperDiv id="outstandingSection" key={ index }>
                                <PlaylistsViewTitle>{playlistGroup.name}</PlaylistsViewTitle>
                                <PlaylistsViewWrapper
                                    id={playlistGroup.id}
                                    items={playlistGroup.playlists}
                                    type="playlist"
                                />
                            </WrapperDiv>
                        )
                    } ) }
                </Col>
            </Row>
        </Container>
    )
}

const mapStateToProps = ( state ) => (
    {
        BUfilterArray: state.filters.BUfilterArray,
        DfilterArray: state.filters.DfilterArray
    });

export default connect( mapStateToProps, {} )( PlaylistGroups );
